import { Component } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '../../components/shared/icon/icon.component';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-app-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, IconComponent, NgClass, NgIf],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.sass'
})
export class AppLayoutComponent {
  isSidebarOpen = true;
  isMobileMenuOpen = false;

  constructor(public authService: AuthenticationService) {}

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  logout() {
    this.authService.logout().subscribe();
  }
}
